export default {
  login: {
    login: '登入',
    loginSubtitle: '登入你的帳號',
    username: '帳號',
    password: '密碼',
    usernamePlaceholder: '用戶名/電話號碼/E-mail',
    forgetPassword: '忘記密碼?'
  },
  register: {
    register: '註冊',
    postfix: '請填寫您的賬號信息',
    telephone: '電話號碼',
    confirmPassword: '確認密碼',
    password: '密碼',
    region: '註冊地區',
    regionPlaceholder: '請選擇地區',
    veriCodeHint: '發送及填寫短信驗證碼',
    sendVeriCode: '發送驗證碼',
    smsVeriCode: '短信驗證碼',
    referralCodeHint: '填寫介紹人推薦碼',
    referralCode: '介紹人推薦碼',
    sent: '已發送',
    actionFail: '操作未能完成',
    alertMsg: {
      required: '尚有資料未填寫',
      registering: '驗證中...',
      logining: '登入中...',
      regConfirmPrefix:'確認以',
      regConfirmPostfix:'作為你的登錄賬戶？',
    },
    terms:{
      labelPrefix:'我已同意本網站的',
      privacy:'隱私條例',
      and:'及',
      userTerms:'用戶協議',
    }
  },
  forgetPassword: {
    forgetPassword: '重設密碼',
    forgetPasswordSubtitle: '輸入以下資料重設密碼',
    username: '用戶名稱',
    backToLogin: '回去登入',
    success: '你的密碼已被重設，即將於5秒內返回登入頁面',
    oneTimePassword: '輸入你的一次性密碼',
    newPassword: '輸入你的新密碼',
    confirmNewPassword: '確認你的新密碼',
    example: '例子: 12345678 (手提電話號碼)',
    advise: '你的密碼長度應至小為8位，以及包含數字/大小寫字母',
    notice: '你的一次性験證碼已經發出，請在稍後時間檢查你的信息',
    sendOneTimePassword: '發送一次性密碼',
    countryCallingCode: '國際區號',
    fail: '你輸入的資料不正確，請重新確認',
    sendOneTimePasswordAgain: '一次性密碼再次發送於：',
    cooldown: '一次性密碼冷卻中，請稍後再試',
    choice: '請選擇'
  }
}




// WEBPACK FOOTER //
// ./src/Auth/langs/zh_hk/index.js